import { clsx } from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { TITLE_FIELD_KEY } from '@tribeplatform/react-components/CustomField'
import {
  PostHiddenIndicator,
  PostLockedIndicator,
} from '@tribeplatform/react-components/Post'
import { useRouter } from '@tribeplatform/react-sdk'

import { StaticField } from '../../Views/types.js'
import { getLinkToUrl } from '../utils/index.js'

const getPostTitle = (post: Post) => {
  const titleField = post?.fields?.find(field => field.key === TITLE_FIELD_KEY)
  const nativePostTitle = post?.title

  if (!titleField) {
    return nativePostTitle
  }

  try {
    const title = JSON.parse(titleField.value) as string
    return title
  } catch (error) {
    logger.error('Failed to parse title field value')
    return nativePostTitle
  }
}

interface Props {
  field: StaticField
  post: Post
  highlighted: boolean
  stretchX: string
  titleSizeClass: string
  linkTo: string
  preview: boolean
  isSinglePost: boolean
  isPostPage: boolean
}
export const PostTitle = ({
  field,
  post,
  highlighted,
  stretchX,
  titleSizeClass,
  linkTo,
  preview,
  isSinglePost,
  isPostPage,
}: Props) => {
  const { Link } = useRouter()
  const linkToUrl = getLinkToUrl({ linkTo, post })
  const { default: defaultTitle } = field
  const postTitle = getPostTitle(post)
  const title = postTitle || (preview ? defaultTitle : '')
  const isHidden = post?.isHidden
  const isLocked = post?.locked

  if (isSinglePost && isPostPage) {
    return (
      <div
        className={clsx(
          stretchX,
          'min-w-0 break-words',
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
      >
        <h2 className={clsx('text-content', titleSizeClass)}>
          {isHidden && <PostHiddenIndicator />}
          {isLocked && <PostLockedIndicator />}
          {title}
        </h2>
      </div>
    )
  }

  return (
    <Link
      href={linkToUrl}
      variant="inherit"
      className={clsx(stretchX, 'break-words min-w-0')}
      onClick={e => e.stopPropagation()}
    >
      <h2
        className={clsx(
          'text-content line-clamp-3',
          titleSizeClass,
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
      >
        {isHidden && <PostHiddenIndicator />}
        {isLocked && <PostLockedIndicator />}
        {title}
      </h2>
    </Link>
  )
}
